/* ===============================
   GLOBALS (same as PDP style)
   =============================== */
let userCity = '';
const resultDiv = document.getElementById('locationResult');

/* ===============================
   LOCATION MAP (same as PDP)
   =============================== */
const locationMap = {
  69840437402: "Santacruz, Mumbai",
  69840830618: "Ahmedabad",
  106251911531: "Delhi",
  69840961690: "Hyderabad",
  69840896154: "Surat",
  105350463851: "Mumbai Online Exclusives, Thane",
  109879034219: "KDH",
  69840863386: "Bangalore",
  69840732314: "Delhi",
  106251845995: "Indore",
  110510670187: "Ludhiana",
  115202654571: "Surat-Men's",
  109719716203: "Mumbai Kala Ghoda",
  110858928491: "Delhi"
};

/* ===============================
   CLEAR ICON VISIBILITY HELPER
   =============================== */
function updateClearIconVisibility(hasPincode) {
  const clearIcon = document.querySelector('.claercrossicon');
  if (clearIcon) {
    clearIcon.style.display = hasPincode ? 'inline-block' : 'none';
  }
}

/* ===============================
   MAIN ZIP CHECK (PLP)
   =============================== */
let isFetchingLocation = false;

function getLocationDetails() {
  const resultDiv = document.querySelector('#locationResult');
  if (resultDiv) {
    resultDiv.classList.remove('hidden');
    resultDiv.textContent = "Valid 6-digit PIN required";
  }
  
  if (isFetchingLocation) return;
  isFetchingLocation = true;

  const input = document.getElementById("pincodeInput");
  const pincode = input?.value?.trim();

  if (!pincode || pincode.length !== 6) {
    isFetchingLocation = false;
    return;
  }
  if (resultDiv) {
    resultDiv.classList.add('hidden');
  }

  /* ✅ Check against zipCodeList */
  const zipList = window.zipCodeList || [];
  const isPincodeAvailable = zipList.map(String).includes(String(pincode));

  /* ✅ Update selected zip UI */
  const selectedZipText = document.querySelector('.selected-zip span');

  /* ✅ Remove active from saved addresses */
  document.querySelectorAll('.zip-code-input-popup li')
    .forEach(li => li.classList.remove('active'));

  fetch(`https://api.postalpincode.in/pincode/${pincode}`)
    .then(res => res.json())
    .then(data => {
      if (data[0]?.Status === "Success") {
        closeZipPopup();
        userCity = data[0].PostOffice[0].District;

        processPLPBadges(userCity, isPincodeAvailable);

        localStorage.setItem('plp_selected_address_city', userCity);
        if (selectedZipText) {
          selectedZipText.textContent = pincode;
        }
        localStorage.setItem('plp_selected_pincode', pincode);

        // ✅ Show the clear cross icon
        updateClearIconVisibility(true);
      } else if (resultDiv) {
        hideAllPLPBadges();
        resultDiv.classList.remove('hidden');
        resultDiv.textContent = "Valid 6-digit PIN required";
      }
    })
    .catch(() => {
      if (resultDiv) {
        hideAllPLPBadges();
        resultDiv.classList.remove('hidden');
        resultDiv.textContent = "Error fetching location. Please try again.";
      }
    })
    .finally(() => {
      isFetchingLocation = false;
    });
}

/* ===============================
   CLEAR PINCODE FUNCTION
   =============================== */
function clearpincode(e) {
  // Prevent opening the popup when clicking the cross icon
  if (e) {
    e.stopPropagation();
    e.preventDefault();
  }

  // 1. Clear input field
  const input = document.getElementById("pincodeInput");
  if (input) {
    input.value = "";
  }

  // 2. Hide error message
  const resultDiv = document.querySelector("#locationResult");
  if (resultDiv) {
    resultDiv.classList.add("hidden");
    resultDiv.textContent = "";
  }

  // 3. Reset selected zip label
  const selectedZipText = document.querySelector(".selected-zip span");
  if (selectedZipText) {
    selectedZipText.textContent = "Pincode";
  }

  // 4. Remove active highlight from saved addresses
  document.querySelectorAll(".zip-code-input-popup li").forEach(li => {
    li.classList.remove("active");
  });

  // 5. Reset global userCity
  userCity = "";

  // 6. Reset all PLP product badges
  hideAllPLPBadges();

  // 7. Clear localStorage
  localStorage.removeItem("plp_selected_pincode");
  localStorage.removeItem("plp_selected_address_city");
  localStorage.removeItem("plp_selected_address_key");

  // 8. ✅ Hide the clear cross icon
  updateClearIconVisibility(false);
}

window.clearpincode = clearpincode;

/* ===============================
   PROCESS ALL PLP PRODUCTS
   =============================== */
function processPLPBadges(userCity, isPincodeAvailable = false) {
  document.querySelectorAll('.plp-delivery-badge')
    .forEach(badge => processSinglePLPBadge(badge, userCity, isPincodeAvailable));
}

/* ===============================
   PROCESS SINGLE PRODUCT BADGE
   =============================== */
function processSinglePLPBadge(badgeEl, userCity, isPincodeAvailable = false) {
  if (!badgeEl || !userCity) return;

  const rawData = badgeEl.dataset.variantInventory;
  if (!rawData) return;

  let parsed;
  try {
    parsed = JSON.parse(rawData.replace(/&quot;/g, '"'));
  } catch {
    return;
  }

  const inventory = parsed?.[0]?.inventory || [];
  const mtoDays = Number(badgeEl.dataset.mtoRtsDays || 0);
  if (!inventory.length) return;

  const locations = inventory.map(loc => ({
    qty: Number(loc.quantity) || 0,
    name: locationMap[loc.location?.id] || ""
  }));

  const totalStoreQty = locations.reduce((s, l) => s + l.qty, 0);

  const isRTSInCity = locations.some(loc =>
    loc.qty > 0 &&
    loc.name.trim() !== "" &&
    (
      loc.name.toLowerCase().includes(userCity.toLowerCase()) ||
      userCity.toLowerCase().includes(loc.name.toLowerCase())
    )
  );

  const sameDay  = badgeEl.querySelector('.same-day');
  const nextDay  = badgeEl.querySelector('.next-day');
  const threeDay = badgeEl.querySelector('.three-day');
  const rtsLabel = badgeEl.closest('.product-card')?.querySelector('.delivery-ready-to-ship');

  [sameDay, nextDay, threeDay].forEach(b => b?.classList.add('hidden'));
  badgeEl.classList.add('hidden');
  rtsLabel?.classList.remove('hidden');

  /* RTS (Same-Day / Next-Day) */
  if (isPincodeAvailable && isRTSInCity) {
    badgeEl.classList.remove('hidden');
    rtsLabel?.classList.add('hidden');

    if (new Date().getHours() < 15) {
      sameDay?.classList.remove('hidden');
    } else {
      nextDay?.classList.remove('hidden');
    }
    return;
  }

  /* MTO (3-Day Delivery) */
  if (!isRTSInCity && mtoDays === 3 && totalStoreQty > 0) {
    badgeEl.classList.remove('hidden');
    threeDay?.classList.remove('hidden');
    rtsLabel?.classList.add('hidden');
  }
}

function hideAllPLPBadges() {
  document.querySelectorAll('.plp-delivery-badge').forEach(badge => {
    badge.classList.add('hidden');

    badge.querySelectorAll('.badge').forEach(b =>
      b.classList.add('hidden')
    );

    const rtsLabel = badge.closest('.product-card')
      ?.querySelector('.delivery-ready-to-ship');

    rtsLabel?.classList.remove('hidden');
  });
}

/* ===============================
   ZIP POPUP INTERACTIONS
   =============================== */
document.addEventListener('DOMContentLoaded', () => {
  const wrap = document.querySelector('.zip-code-plp-wrap');
  if (!wrap) return;

  const popup = wrap.querySelector('.zip-code-input-popup');
  const selectedZip = wrap.querySelector('.selected-zip');
  const selectedZipText = selectedZip?.querySelector('span');
  const closeBtn = wrap.querySelector('#close-location');
  const pincodeInput = wrap.querySelector('#pincodeInput');
  const addressItems = wrap.querySelectorAll('li[data-custome-zip]');

  /* open popup (safeguard: do NOT open if clicking the clear icon) */
  selectedZip?.addEventListener('click', (e) => {
    if (e.target.closest('.claercrossicon')) return;

    popup.classList.add('active');
    document.documentElement.classList.add('location-popup-active');
  });

  /* close popup */
  closeBtn?.addEventListener('click', () => {
    popup.classList.remove('active');
    document.documentElement.classList.remove('location-popup-active');
  });

  /* saved address click */
  const isMobile = window.innerWidth <= 750;
  if (isMobile) {
    addressItems.forEach((li, index) => {
      li.dataset.addressKey ||= index;

      li.addEventListener('click', () => {
        const zip = li.dataset.customeZip;
        const addressKey = li.dataset.addressKey;

        if (!zip) return;

        localStorage.setItem('plp_selected_pincode', zip);
        localStorage.setItem('plp_selected_address_key', addressKey);

        pincodeInput.value = zip;
        selectedZipText.textContent = zip;

        addressItems.forEach(i => i.classList.remove('active'));
        setTimeout(() => {
          li.classList.add('active');
        }, 10);

        popup.classList.remove('active');
        document.documentElement.classList.remove('location-popup-active');

        getLocationDetails();
      });
    });
  }

  const storedPin = localStorage.getItem('plp_selected_pincode');
  const storedAddressKey = localStorage.getItem('plp_selected_address_key');

  if (storedPin) {
    pincodeInput.value = storedPin;
    if (selectedZipText) selectedZipText.textContent = storedPin;
    updateClearIconVisibility(true); // ✅ Show clear icon

    addressItems.forEach((li, index) => {
      setTimeout(() => {
        li.classList.remove('active');
      }, 10);
      if (!li.dataset.addressKey) {
        li.dataset.addressKey = String(index);
      }

      const zip = li.dataset.customeZip;
      const key = li.dataset.addressKey;

      if (
        storedPin &&
        storedAddressKey &&
        zip === storedPin &&
        key === storedAddressKey
      ) {
        setTimeout(() => {
          li.classList.add('active');
        }, 10);
      }
    });
    getLocationDetails();
  } else {
    if (window.customerDefaultPincode && pincodeInput) {
      pincodeInput.value = window.customerDefaultPincode;
      if (selectedZipText) selectedZipText.textContent = window.customerDefaultPincode;
      updateClearIconVisibility(true); // ✅ Show clear icon
      getLocationDetails();
    } else {
      updateClearIconVisibility(false); // ✅ Hide clear icon
    }
  }
});

function closeZipPopup() {
  const popup = document.querySelector('.zip-code-input-popup');
  if (!popup) return;

  popup.classList.remove('active');
  document.documentElement.classList.remove('location-popup-active');
}